import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js/object/get-own-property-symbols";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js/object/define-property";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js/instance/filter";
import _Object$keys from "@babel/runtime-corejs3/core-js/object/keys";
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import OverrideCustomizations from "../../override-customizations";
import InlinePrompt from "@Shared/components/general/inline-prompt";
import FaqTabLoader from "./faq-tab-loader";
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";
import { LOAD_PERSONAL_FAQ, LOAD_BROKERAGE_FAQ, UPDATE_BROKERAGE_FAQ, UPDATE_PERSONAL_FAQ } from "../../store/settings-actions";
import { mapActions, mapState } from "vuex";
import { showToast } from "@Shared/@Utils/constants";
import { cloneDeep, groupBy, reduce } from "lodash";
import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  name: "FaqTab",
  components: {
    FaqTabLoader,
    InlinePrompt,
    OverrideCustomizations
  },
  mixins: [validationMixin],
  props: {
    saving: {
      type: Boolean,
      required: true
    },
    settingsType: {
      type: String,
      required: true
    }
  },
  validations: {
    localFaq: {
      required,
      $each: {
        $each: {
          answer: {
            required
          },
          question: {
            required
          }
        }
      }
    }
  },
  data() {
    return {
      loading: true,
      currentCategory: "",
      localFaq: []
    };
  },
  computed: _objectSpread(_objectSpread({}, mapState("SettingsStore", ["personalFaq", "brokerageFaq"])), {}, {
    faqToUse() {
      return this.settingsType === "brokerage-settings" ? this.brokerageFaq : this.personalFaq;
    },
    isValid() {
      return !this.$v.$invalid;
    },
    categories() {
      var _context;
      return _filterInstanceProperty(_context = _Object$keys(this.localFaq)).call(_context, category => category !== "support");
    },
    currentFaq() {
      return this.localFaq[this.currentCategory] || [];
    }
  }),
  watch: {
    saving(value) {
      if (!value) return;
      this.saveFaq();
    },
    localFaq: {
      handler() {
        this.$emit("allow-save", this.isValid);
      },
      deep: true
    }
  },
  async mounted() {
    if (this.settingsType === "brokerage-settings") {
      await this.LOAD_BROKERAGE_FAQ();
    } else {
      await this.LOAD_PERSONAL_FAQ();
    }
    this.setLocalFaq();
    this.currentCategory = this.categories[0];
    this.loading = false;
  },
  methods: _objectSpread(_objectSpread({}, mapActions("SettingsStore", [LOAD_PERSONAL_FAQ, LOAD_BROKERAGE_FAQ, UPDATE_PERSONAL_FAQ, UPDATE_BROKERAGE_FAQ])), {}, {
    handleAddQuestion() {
      this.localFaq[this.currentCategory] = [...this.localFaq[this.currentCategory], {
        accountType: ["broker", "agent", "client"],
        category: this.currentCategory,
        question: "",
        answer: ""
      }];
    },
    async handleDeleteQuestion(index) {
      var _context2;
      this.localFaq[this.currentCategory] = _filterInstanceProperty(_context2 = this.localFaq[this.currentCategory]).call(_context2, (_, faqIndex) => faqIndex !== index);
    },
    async saveFaq() {
      try {
        if (!this.isValid) return;
        const allFaq = reduce(cloneDeep(this.localFaq), (acc, faqCategory) => {
          acc.push(...faqCategory);
          return acc;
        }, []);
        if (this.settingsType === "brokerage-settings") {
          await this.UPDATE_BROKERAGE_FAQ(allFaq);
        } else {
          await this.UPDATE_PERSONAL_FAQ(allFaq);
        }
        this.$emit("finish-saving", true);
        showToast("success", "informationUpdatedSuccessfully");
      } catch (e) {
        this.$emit("finish-saving", false);
      }
    },
    handleChangeTab(category) {
      this.currentCategory = category;
    },
    tabTitle(category) {
      const parser = {
        general: this.$t("settings.faqTab.generalInquiry"),
        account: this.$t("settings.faqTab.accountRelated"),
        support: this.$t("settings.faqTab.support")
      };
      return parser[category];
    },
    setLocalFaq() {
      const clonedFaq = cloneDeep(this.faqToUse);
      this.localFaq = groupBy(clonedFaq, faq => faq.category);
    }
  })
});